/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pwf_Target_PlaceholderInputs */

const en_pwf_target_placeholder = /** @type {(inputs: Pwf_Target_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a workflow`)
};

const de_pwf_target_placeholder = /** @type {(inputs: Pwf_Target_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow wählen`)
};

/**
* | output |
* | --- |
* | "Choose a workflow" |
*
* @param {Pwf_Target_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pwf_target_placeholder = /** @type {((inputs?: Pwf_Target_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pwf_Target_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pwf_target_placeholder(inputs)
	return en_pwf_target_placeholder(inputs)
});